import {createRouter, createWebHashHistory, createWebHistory} from "vue-router";

// 2. 定义一些路由
// 每个路由都需要映射到一个组件。
// 我们后面再讨论嵌套路由。
const routes = [
    {   path: '/',
        name:'home',
        component:()=> import('../pager/home/home') },
    {   path: '/about',
        name:'about',
        component:()=> import('../pager/about/index') },
    {path: "/info",name: "info",component: ()=> import("../pager/commSimple"),children:[
            // {path: "/viewa",name: "ViewA",component: ()=> import("../views/ViewA")},
            // {path: "/viewb",name: "ViewB",component: ()=> import("../views/ViewB")}
        ]},
    {   path: '/about/profil',
        name:'about/profil',
        component:()=> import('../pager/about/about1') },
    {   path: '/about/honors',
        name:'about/honors',
        component:()=> import('../pager/about/about2') },
    {   path: '/about/culture',
        name:'about/culture',
        component:()=> import('../pager/about/about5') },
    {   path: '/about/responsibility',
        name:'about/responsibility',
        component:()=> import('../pager/about/about6') },
    {   path: '/prduct/mulu',component:()=> import('../pager/product/mulu') },
    {   path: '/prduct/zizhirenzheng',component:()=> import('../pager/product/zizhirenzheng') },
    {   path: '/prduct/yxwl',component:()=> import('../pager/product/yxwl') },
    {   path: '/prduct/jishuchubei',component:()=> import('../pager/product/jishuchubei') },
    {   path: '/prduct/hzhb',component:()=> import('../pager/product/hzhb') },
    {   path: '/prduct/gongyiluxian',component:()=> import('../pager/product/gongyiluxian') },
    {   path: '/technology/team',component:()=> import('../pager/technology/team') },
    {   path: '/technology/patent',component:()=> import('../pager/technology/patent') },
    {   path: '/technology/cooperation',component:()=> import('../pager/technology/cooperation') },
    {   path: '/technology/achievements',component:()=> import('../pager/technology/achievements') },
    {   path: '/technology/zizhirenzheng',component:()=> import('../pager/technology/zizhirenzheng') },
    {   path: '/technology/achievements2/:id',name: 'zl2',component:()=> import('../pager/technology/achievements_detail') },
    {   path: '/part/basic',component:()=> import('../pager/part/basic') },
    {   path: '/part/news',component:()=> import('../pager/part/news') },
    {   path: '/part/study',component:()=> import('../pager/part/study') },
    {   path: '/news',component:()=> import('../pager/news/list') },
    {   path: '/newsDetail',name: "newsDetail",component:()=> import('../pager/news/detail') },
    {   path: '/recruit',component:()=> import('../pager/recruit/list') },
    {   path: '/recruit/:id',name: "recruitDetail",component:()=> import('../pager/recruit/detail') },
    {   path: '/environment',component:()=> import('../pager/environment/index') },
    {   path: '/contact',component:()=> import('../pager/contact/contactUs') },
    {   path: '/services',component:()=> import('../pager/services/index') },

    // {
    //     path: "/about",
    //     name: "About",
    //     // route level code-splitting
    //     // this generates a separate chunk (about.[hash].js) for this route
    //     // which is lazy-loaded when the route is visited.
    //     //懒加载，需要资源的时候才会进行加载，节省资源，减少操作此时，提高效率
    //     component: () =>
    //         import(/* webpackChunkName: "about" */ "../views/About.vue"),
    // },
]

// 3. 创建路由实例并传递 `routes` 配置
// 你可以在这里输入更多的配置，但我们在这里
// 暂时保持简单
const router = createRouter({
    // 4. 内部提供了 history 模式的实现。为了简单起见，我们在这里使用 hash 模式。
    history: createWebHistory(),
    routes, // `routes: routes` 的缩写
})

export default  router
